<template>
  <vbt-error-boundary
    :error="$attrs.error"
    :no-content="!items.length"
    >
    <vbt-table
      :headers="headers"
      :items="items"
      show-paginator
    >
      <template #processed="{ item: { processed } }">
        {{ formatDate(processed, { dateFormat: 'yyyy-MM-dd, hh:mm:ss.SSS a' }) }}
      </template>
    </vbt-table>
  </vbt-error-boundary>
</template>

<script>
import { formatDate } from '@helpers';

const headers = Object.freeze([
  { text: 'Operator', value: 'operator' },
  { text: 'Processed Date', value: 'processed' },
  { text: 'Description', value: 'description' },
]);

export default {
  name: 'KernelPressSheetHistoryList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({ headers }),
  methods: {
    formatDate,
  },
};
</script>
